import styled from 'styled-components'
import { InfoList as InfoListStyle } from '../../FirstColumn/_styles'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 100%;
`

export const Row = styled.div`
  display: flex;
  flex-direction: row;

  ${InfoListStyle} {
    margin-bottom: 8px;
  }
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  &:not(:last-child) {
    margin-right: 20px;
  }
`
